import { useEffect, useState } from "react";
import { PLANS, PUBLIC_API_URL } from "@/constants/site";

function mergePlans(records) {
  const byCode = new Map();

  records.forEach((record) => {
    const code = String(record.code || "").toLowerCase();
    if (!code) return;

    const current = byCode.get(code) || { code };
    const currency = String(record.currencyCode || "").toUpperCase();
    const priceMinor = Number(record.priceMinor);
    if (currency === "NGN" && Number.isFinite(priceMinor)) current.priceMinor = priceMinor;
    if (currency === "USD" && Number.isFinite(priceMinor)) current.usdPriceMinor = priceMinor;

    byCode.set(code, {
      ...current,
      name: record.name || current.name,
      description: record.description || current.description,
      maxBranches: Number(record.maxBranches) || current.maxBranches,
      maxStaff: Number(record.maxStaff) || current.maxStaff,
      maxProducts: Number(record.maxProducts) || current.maxProducts,
      includedCredits: Number(record.includedCredits) || current.includedCredits,
      sortOrder: Number(record.sortOrder) || current.sortOrder || 0,
    });
  });

  return PLANS.map((fallback) => ({ ...fallback, ...(byCode.get(fallback.code) || {}) }));
}

export function usePublicPlans() {
  const [plans, setPlans] = useState(PLANS);
  const [source, setSource] = useState("fallback");

  useEffect(() => {
    const controller = new AbortController();

    fetch(`${PUBLIC_API_URL}/api/v1/config/bootstrap?platform=web`, {
      signal: controller.signal,
      headers: { Accept: "application/json" },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`pricing request failed: ${response.status}`);
        return response.json();
      })
      .then((payload) => {
        const records = payload?.configuration?.plans;
        if (Array.isArray(records) && records.length > 0) {
          setPlans(mergePlans(records));
          setSource("service");
        }
      })
      .catch((error) => {
        if (error.name !== "AbortError") setSource("fallback");
      });

    return () => controller.abort();
  }, []);

  return { plans, source };
}
